import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
    routes,
    linkActiveClass: 'active',
    mode: 'history',
    scrollBehavior: (to, from, savedPosition) => {
        if (savedPosition) return savedPosition;
        if (to.hash) return { selector: to.hash };
        return { x: 0, y: 0 };
    }
});

router.beforeResolve((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then(() => {
            next()
        }).catch(() => {
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            });
        });
    }
    next();
});

export default router;